import { Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { fuelTypesService } from '../../../api/services'
import type { FuelTypeItem } from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const columns: ColumnConfig<FuelTypeItem>[] = [
  { header: 'ID', render: (i) => <Text fontFamily="monospace" fontSize="sm" color={themeColors.textSecondary}>{i.id}</Text> },
  { header: 'Combustible', render: (i) => <Text fontSize="sm" color={themeColors.text}>{i.description}</Text> },
  { header: 'Factor de Emisión', render: (i) => <Text fontSize="sm" color={themeColors.text}>{i.emissionFactorKgCo2e}</Text> },
  { header: 'Unidad', render: (i) => <Text fontSize="sm" color={themeColors.textSecondary}>{i.emissionUnit}</Text> },
  { header: 'Fuente', render: (i) => <Text fontSize="sm" color={themeColors.textSecondary}>{i.emissionSource}</Text> },
]

const fields: FieldConfig<FuelTypeItem>[] = [
  { name: 'emissionFactorKgCo2e', label: 'Factor de emisión (kg CO2e por unidad)', type: 'number', required: true, colSpan: 2, step: 0.01 },
  { name: 'emissionUnit', label: 'Unidad', type: 'text', required: true, colSpan: 1 },
  { name: 'emissionSource', label: 'Fuente referencial', type: 'text', colSpan: 1 },
]

export default function FuelTypesPage() {
  return (
    <CatalogoBasePage<FuelTypeItem, number>
      title="Factores de Emisión por Combustible"
      subtitle="Factor de emisión MINAM (kg CO2e por galón/m³) usado en el cálculo de huella de carbono"
      entityName="factor de combustible"
      service={fuelTypesService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(i) => String(i.id)}
      idExtractor={(i) => i.id}
      isLookupOnly
      searchPlaceholder="Buscar combustible..."
      updatePermission="masters.write"
    />
  )
}
